<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="赛事编号" prop="competitionId" >-->
<!--        <a-input v-model="form.competitionId" placeholder="请输入赛事编号" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="模板" prop="templateId" >
<!--        <a-input v-model="form.templateId" placeholder="请输入模板编号" />-->
        <a-select placeholder="请选择模板" v-model="form.templateId">
          <a-select-option v-for="(row, index) in templateList" :key="row.id" :value="row.id" >{{ row.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="模板图片" prop="templateImage" >-->
<!--        <file-upload v-model="form.templateImage" type="image"></file-upload>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="获奖称号" prop="awardsName" >-->
<!--        <a-input v-model="form.awardsName" placeholder="请输入获奖称号" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="发证单位" prop="issueUnit" >
        <a-input v-model="form.issueUnit" placeholder="请输入发证单位" />
      </a-form-model-item>
      <a-form-model-item label="赛事标题" prop="competitionTitle" >
        <a-input v-model="form.competitionTitle" placeholder="请输入赛事标题" />
      </a-form-model-item>
      <a-form-model-item label="原图章" prop="originalSeal" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          :customRequest='fileUploadRequest'
          :beforeUpload="beforeUpload"
          @change="handleChange"
        >
          <img v-if="form.originalSeal" :src="form.originalSeal" alt="原图章" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">图片限制小于5M </span>
      </a-form-model-item>
      <a-form-model-item label="图章" prop="seal" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          :customRequest='fileUploadRequest2'
          :beforeUpload="beforeUpload2"
          @change="handleChange2"
        >
          <img v-if="form.seal" :src="form.seal" alt="图章" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading2 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">图片限制小于5M </span>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompetitionCertificate, addCompetitionCertificate, updateCompetitionCertificate } from '@/api/platform/competitionCertificate'
import {listCompetitionTemplate} from "@/api/platform/competitionTemplate";
import UploadFileToOSS from "@/utils/upload-file-to-oss";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      templateList: [],
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        competitionId: null,

        templateId: null,

        templateImage: null,

        awardsName: null,

        issueUnit: null,

        competitionTitle: null,

        originalSeal: null,

        seal: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
     this.templateInit()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    templateInit(){
      listCompetitionTemplate().then(response => {
        this.templateList = response.data
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        competitionId: null,
        templateId: null,
        templateImage: null,
        awardsName: null,
        issueUnit: null,
        competitionTitle: null,
        originalSeal: null,
        seal: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompetitionCertificate({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompetitionCertificate(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompetitionCertificate(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          console.log("res========>"+JSON.stringify(res))
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url;
          fileInfo.file.ossUrl = ossUrl;
          fileInfo.file.ossName = ossUrl;
          fileInfo.onSuccess();
        },
      });
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if(file.size>5*1024*1000){
          this.$message.warning("图片大小不能超过5M----")
          return reject(false)
        }

        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return reject(false);
        }
        resolve(true)
      });
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        // let response = info.file.response;
        this.uploadLoading = false;
        this.form.originalSeal = info.file.originFileObj.ossUrl;
      }
    },
    fileUploadRequest2(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          console.log("res========>"+JSON.stringify(res))
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url;
          fileInfo.file.ossUrl = ossUrl;
          fileInfo.file.ossName = ossUrl;
          fileInfo.onSuccess();
        },
      });
    },
    beforeUpload2: function (file) {
      return new Promise((resolve, reject) => {
        if(file.size>5*1024*1000){
          this.$message.warning("图片大小不能超过5M----")
          return reject(false)
        }

        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return reject(false);
        }
        resolve(true)
      });
    },
    handleChange2(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        // let response = info.file.response;
        this.uploadLoading = false;
        this.form.seal = info.file.originFileObj.ossUrl;
      }
    }
  }
}
</script>
